import { DemographicsDataProviders } from '~/store/demographics/demographics.types';
import type { DemographicsListPremiumAction } from './demographicsListPremium.action';
import {
  demographicsListPremiumFetchDataError,
  demographicsListPremiumFetchDataStart,
  demographicsListPremiumFetchDataSuccess,
} from './demographicsListPremium.actionCreators';
import type { DemographicsListPremiumState } from './demographicsListPremium.state';

const initialState: DemographicsListPremiumState = {
  isLoading: false,
  isDataFetched: false,
  ...Object.values(DemographicsDataProviders).reduce(
    (acc, provider) => ({ ...acc, [provider]: [] }),
    {} as { [K in typeof DemographicsDataProviders[keyof typeof DemographicsDataProviders]]: [] }
  ),
};

export function demographicsListPremiumReducer(
  state = initialState,
  action: DemographicsListPremiumAction,
): DemographicsListPremiumState {
  if (demographicsListPremiumFetchDataStart.match(action)) {
    return {
      ...state,
      isLoading: true,
    };
  }

  if (demographicsListPremiumFetchDataError.match(action)) {
    return {
      ...state,
      isLoading: false,
    };
  }

  if (demographicsListPremiumFetchDataSuccess.match(action)) {
    return {
      ...state,
      isLoading: false,
      isDataFetched: true,
      ...action.payload.providers,
    };
  }

  return state;
}
